import { render, staticRenderFns } from "./ExportPallet.vue?vue&type=template&id=1e765544"
import script from "./ExportPallet.vue?vue&type=script&lang=js"
export * from "./ExportPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports